import { Component } from "@angular/core";

@Component({
  selector: "mainContainer",
  templateUrl: "./mainContainer.html",
  styleUrls: ["./mainContainer.scss"]
})
export class MainContainerComponent {}
